/* eslint-disable no-param-reassign */
import {
  SignMessageRequest,
  encodeMsgpack,
  parseSignMessageResponse,
  DappRequestType,
  SignMessageResponse,
} from 'dapp'
import { config as globalConfig } from './config'
import { formatResponse } from './format'
import { PopupConfigOptions, openPopup, runPopup } from './popup'

export const generateJoyIDSignMessageURL = (
  request: SignMessageRequest,
  type: 'popup' | 'redirect'
) => {
  const joyidURL = globalConfig.getJoyIDAppURL()
  const url = new URL(`${joyidURL}/sign-message`)
  let redirectTo = request.redirectURL
  if (type === 'redirect') {
    const redirectURL = new URL(redirectTo)
    redirectURL.searchParams.set('joyid-redirect', 'true')
    redirectTo = redirectURL.href
  }
  url.searchParams.set('type', type)
  url.hash = encodeMsgpack({
    ...request,
    redirectURL: redirectTo,
  })
  return url.href
}

export const generateSignURL = generateJoyIDSignMessageURL

export const signMessageWithRedirect = (request: SignMessageRequest) => {
  location.href = generateJoyIDSignMessageURL(request, 'redirect')
}

export const signWithRedirect = signMessageWithRedirect

export const signMessageCallback = () => {
  try {
    return formatResponse(
      parseSignMessageResponse(location.hash.slice(1))
    ) as SignMessageResponse
  } catch (error) {
    return {
      type: DappRequestType.SignMessage,
      error: error instanceof Error ? error.message : error,
    } as SignMessageResponse
  }
}

export const signCallback = signMessageCallback

export const signMessageWithPopup = async (
  request: SignMessageRequest,
  config?: Pick<PopupConfigOptions, 'timeoutInSeconds' | 'popup'>
) => {
  config = config || {}
  if (!config.popup) {
    config.popup = openPopup('')

    if (!config.popup) {
      throw new Error(
        'Unable to open a popup for loginWithPopup - window.open returned `null`'
      )
    }
  }

  config.popup.location.href = generateJoyIDSignMessageURL(request, 'popup')

  try {
    const res = await runPopup<SignMessageResponse>({
      ...config,
      type: DappRequestType.SignMessage,
    })
    return res
  } catch (error) {
    return {
      state: request.state,
      type: DappRequestType.SignMessage,
      error: error instanceof Error ? error.message : error,
    } as SignMessageResponse
  }
}

export const signWithPopup = signMessageWithPopup
